export const formatDate = (date, withTime = false) => {
  if (!date) return "";

  const d = new Date(date);
  if (isNaN(d)) return "";

  return new Date(date).toLocaleDateString("ru-RU", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    ...(withTime && {
      hour: "2-digit",
      minute: "2-digit",
    }),
  });
};

export const parseDateDDMMYYYY = (str) => {
  if (!str) return null
  const s = String(str).trim()
  const match = s.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/)
  if (match) {
    const [, d, m, y] = match
    const date = new Date(Number(y), Number(m) - 1, Number(d))
    return isNaN(date.getTime()) ? null : date
  }
  const iso = new Date(s)
  return isNaN(iso.getTime()) ? null : iso
}
